<template>
  <div
    class="add-bank-account-page"
    :class="$vuetify.theme.dark ? 'add-bank-account--dark' : 'add-bank-account--light'"
  >
  <div class="add-bank-account-shell">
    <div class="add-bank-account-heading">
      <span class="heading-icon"><v-icon>mdi-bank-plus</v-icon></span>
      <div>
        <h2>Add Bank Account</h2>
        <p>Save your bank details for secure deposits and withdrawals.</p>
      </div>
    </div>

  <v-stepper v-model="e1" class="password-stepper create-account-stepper" elevation="0">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
        Account Details
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" color="#708AA7"> Bank Address </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <!-- Step 1 -->
      <v-stepper-content step="1">
        <v-card class="deposit-form create-account-form" color="transparent">
          <v-form ref="step1Form" v-model="step1Valid">
            <v-row dense>
              <!-- Bank Name -->
              <v-col cols="12">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-text-field
                    v-model="bankInfo.bank_name"
                    label="Enter Bank Name"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Bank Account Name -->
              <v-col cols="12">
                <fieldset>
                  <legend>Bank Account Name</legend>
                  <v-text-field
                    v-model="bankInfo.bank_acc_name"
                    label="Bank Account Name"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Account No -->
              <v-col cols="12">
                <fieldset>
                  <legend>Account No</legend>
                  <v-text-field
                    v-model="bankInfo.bank_acc_num"
                    label="Account No"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required, rules.numeric]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Optional Fields -->
              <v-col cols="12">
                <fieldset>
                  <legend>IBAN Number</legend>
                  <v-text-field
                    v-model="bankInfo.bank_iban_num"
                    label="IBAN Number"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field
                    v-model="bankInfo.ifsc_code"
                    label="IFSC Code"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                <fieldset>
                  <legend>Bank Swift Code</legend>
                  <v-text-field
                    v-model="bankInfo.bank_swift_num"
                    label="Bank Swift Code"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Next Step Button -->
              <v-col cols="12">
                <v-btn
                  class="text-capitalize btn-account"
                  color="greenMain"
                  tile
                  elevation="0"
                  @click="goToStep2"
                >
                  Next Step
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-stepper-content>

      <!-- Step 2 -->
      <v-stepper-content step="2">
        <v-card class="deposit-form password-field create-account-form" color="transparent">
          <v-row dense>
            <v-col cols="12">
              <fieldset>
                <legend>Bank Country</legend>
                <v-select
                  v-model="bankInfo.bank_residence_country"
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  @change="onCountryChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>State Province</legend>
                <v-select
                  v-model="bankInfo.bank_residence_state"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  @change="onStateChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>City</legend>
                <v-select
                  v-model="bankInfo.bank_residence_city"
                  :items="cities"
                  item-text="name"
                  item-value="id"
                  @change="onCityChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>Postal Code</legend>
                <v-text-field
                  v-model="bankInfo.bank_postal_code"
                  label="Enter here"
                  single-line
                  solo
                  hide-details
                  class="custom-select"
                ></v-text-field>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>Bank Address</legend>
                <v-text-field
                  v-model="bankInfo.bank_address"
                  label="Enter here"
                  single-line
                  solo
                  hide-details
                  class="custom-select"
                ></v-text-field>
              </fieldset>
            </v-col>

            <div class="form-actions">
              <v-btn
                class="ma-0 text-capitalize back-button"
                elevation="0"
                @click="e1 = 1"
              >
                <v-icon left small>mdi-arrow-left</v-icon>
                Back
              </v-btn>
              <v-btn
                class="ma-0 text-capitalize btn-account"
                color="greenMain"
                tile
                width="146px"
                elevation="0"
                @click="handleSubmit"
                :loading="loading"
              >
                Create Account
              </v-btn>
            </div>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
  </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  BANK__ACTIONS,
  COUNTRIES__ACTIONS,
  CITIES__ACTIONS,
  STATES__ACTIONS
} from "@/store/action-types";

export default {
  name: "BankForm",
  data() {
    return {
      e1: 1,
      step1Valid: false,
      loading: false,
      bankInfo: {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "",
        bank_swift_num: "",
        ifsc_code: "",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: ""
      },
      rules: {
        required: v => !!v || "This field is required",
        numeric: v =>
          /^[0-9]+$/.test(v) || "Account number must be numeric"
      }
    };
  },
  computed: {
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"])
  },
  methods: {
    ...mapActions("bank", [BANK__ACTIONS.CREATE]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),

    async onCountryChange(value) {
      this.bankInfo.bank_residence_country = value;
      this.bankInfo.bank_residence_state = "";
      this.bankInfo.bank_residence_city = "";
      await this[STATES__ACTIONS.STATES](value);
    },

    async onStateChange(value) {
      this.bankInfo.bank_residence_state = value;
      this.bankInfo.bank_residence_city = "";
      await this[CITIES__ACTIONS.CITIES](value);
    },

    onCityChange(value) {
      this.bankInfo.bank_residence_city = value;
    },

    async handleSubmit() {
      this.loading = true;
      try {
        await this[BANK__ACTIONS.CREATE](this.bankInfo);
        this.resetForm();
      } catch (error) {
        console.error("Error creating bank account:", error);
      } finally {
        this.loading = false;
      }
    },

    goToStep2() {
      if (this.$refs.step1Form.validate()) {
        this.e1 = 2;
      }
    },

    resetForm() {
      this.bankInfo = {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "",
        bank_swift_num: "",
        ifsc_code: "",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: ""
      };
      this.e1 = 1;
    }
  },
  async mounted() {
    await this[COUNTRIES__ACTIONS.COUNTRIES]();
    if (this.bankInfo.bank_residence_country) {
      await this[STATES__ACTIONS.STATES](this.bankInfo.bank_residence_country);
    }
    if (this.bankInfo.bank_residence_state) {
      await this[CITIES__ACTIONS.CITIES](this.bankInfo.bank_residence_state);
    }
  }
};
</script>

<style scoped>
.add-bank-account-page {
  --bank-accent: #d99a00;
  --bank-accent-soft: rgba(217, 154, 0, 0.12);
  --bank-bg: #f7f8fa;
  --bank-panel: #ffffff;
  --bank-field: #f4f5f7;
  --bank-border: #dfe2e6;
  --bank-text: #171a1f;
  --bank-muted: #626973;
  height: calc(100vh - 64px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: var(--bank-bg);
  color: var(--bank-text);
}
.add-bank-account--dark {
  --bank-accent: #ffc400;
  --bank-accent-soft: rgba(255, 196, 0, 0.12);
  --bank-bg: #030b13;
  --bank-panel: #07111b;
  --bank-field: #0b1621;
  --bank-border: #293026;
  --bank-text: #f4f5f7;
  --bank-muted: #aeb6c0;
}
.add-bank-account-shell {
  width: min(100%, 920px);
  padding: 24px 28px 48px;
}
.add-bank-account-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.heading-icon {
  display: grid;
  place-items: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border: 1px solid var(--bank-accent);
  border-radius: 10px;
  background: var(--bank-accent-soft);
}
.heading-icon .v-icon { color: var(--bank-accent) !important; }
.add-bank-account-heading h2 {
  margin: 0;
  color: var(--bank-text);
  font-size: 23px;
  line-height: 1.25;
}
.add-bank-account-heading p {
  margin: 4px 0 0;
  color: var(--bank-muted);
  font-size: 13px;
}
.add-bank-account-page ::v-deep .create-account-stepper {
  border: 1px solid var(--bank-border) !important;
  border-radius: 10px !important;
  background: var(--bank-panel) !important;
  color: var(--bank-text) !important;
  overflow: hidden;
}
.add-bank-account-page ::v-deep .v-stepper__header {
  height: auto;
  min-height: 76px;
  padding: 0 24px;
  border-bottom: 1px solid var(--bank-border);
  box-shadow: none;
  background: var(--bank-panel);
}
.add-bank-account-page ::v-deep .v-stepper__step { padding: 20px 12px; }
.add-bank-account-page ::v-deep .v-stepper__step__step {
  background: var(--bank-field) !important;
  color: var(--bank-muted) !important;
}
.add-bank-account-page ::v-deep .v-stepper__step--active .v-stepper__step__step,
.add-bank-account-page ::v-deep .v-stepper__step--complete .v-stepper__step__step {
  background: var(--bank-accent) !important;
  color: #101010 !important;
}
.add-bank-account-page ::v-deep .v-stepper__label { color: var(--bank-muted) !important; text-shadow: none !important; }
.add-bank-account-page ::v-deep .v-stepper__step--active .v-stepper__label { color: var(--bank-text) !important; }
.add-bank-account-page ::v-deep .v-divider { border-color: var(--bank-border) !important; }
.add-bank-account-page ::v-deep .v-stepper__content { margin: 0; padding: 26px; }
.add-bank-account-page ::v-deep .create-account-form { max-width: none; background: transparent !important; }
.add-bank-account-page ::v-deep fieldset {
  display: block !important;
  min-width: 0;
  width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  overflow: visible !important;
}
.add-bank-account-page ::v-deep legend {
  display: block !important;
  float: none !important;
  width: auto !important;
  margin: 0 0 7px !important;
  padding: 0 !important;
  position: static !important;
  inset: auto !important;
  transform: none !important;
  white-space: normal !important;
  background: transparent !important;
  color: var(--bank-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}
.add-bank-account-page ::v-deep .v-input__slot {
  min-height: 48px !important;
  margin: 0 !important;
  padding: 0 14px !important;
  border: 1px solid var(--bank-border) !important;
  border-radius: 6px !important;
  background: var(--bank-field) !important;
  box-shadow: none !important;
}
.add-bank-account-page ::v-deep .create-account-form .row--dense > .col,
.add-bank-account-page ::v-deep .create-account-form .row--dense > [class*="col-"] {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}
.add-bank-account-page ::v-deep .custom-select {
  display: block !important;
  width: 100%;
  min-height: 48px;
  margin: 0 !important;
  padding: 0 !important;
}
.add-bank-account-page ::v-deep .v-text-field__details {
  min-height: 15px;
  margin: 3px 0 0 !important;
  padding: 0 2px !important;
}
.add-bank-account-page ::v-deep .v-messages { min-height: 14px; }
.add-bank-account-page ::v-deep .v-messages__message { line-height: 14px; }
.add-bank-account-page ::v-deep .v-input--is-focused .v-input__slot {
  border-color: var(--bank-accent) !important;
}
.add-bank-account-page ::v-deep .v-input input,
.add-bank-account-page ::v-deep .v-select__selection {
  color: var(--bank-text) !important;
  font-size: 14px;
}
.add-bank-account-page ::v-deep .v-input input {
  min-height: 46px;
  padding: 0 !important;
  line-height: 46px;
}
.add-bank-account-page ::v-deep input::placeholder { color: var(--bank-muted) !important; opacity: 0.72; }
.add-bank-account-page ::v-deep .v-label { color: var(--bank-muted) !important; }
.add-bank-account-page ::v-deep .v-icon { color: var(--bank-accent) !important; }
.add-bank-account-page ::v-deep .btn-account {
  min-width: 146px;
  min-height: 42px;
  border-radius: 6px !important;
  background: var(--bank-accent) !important;
  color: #101010 !important;
  font-weight: 700;
}
.form-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 0;
  margin: 10px 0 0;
  padding: 0;
}
.add-bank-account-page ::v-deep .back-button {
  min-width: 146px;
  width: 146px !important;
  flex: 0 0 146px;
  min-height: 42px;
  margin-left: 6px !important;
  margin-bottom: 6px !important;
  border: 1px solid var(--bank-accent) !important;
  border-top: 1px solid var(--bank-accent) !important;
  border-right: 1px solid var(--bank-accent) !important;
  border-bottom: 1px solid var(--bank-accent) !important;
  border-left: 1px solid var(--bank-accent) !important;
  border-radius: 6px !important;
  background: var(--bank-accent-soft) !important;
  box-shadow:
    inset 1px 0 0 var(--bank-accent),
    inset 0 -1px 0 var(--bank-accent) !important;
  box-sizing: border-box;
  color: var(--bank-accent) !important;
  font-weight: 700;
  letter-spacing: 0;
}
.add-bank-account-page ::v-deep .back-button::before { opacity: 0 !important; }
.add-bank-account-page ::v-deep .back-button:hover { background: rgba(255, 196, 0, 0.2) !important; }
.add-bank-account-page ::v-deep .back-button .v-icon { color: var(--bank-accent) !important; }
.add-bank-account-page ::v-deep .password-field.create-account-form {
  max-width: none !important;
  padding: 0 !important;
}

@media (max-width: 600px) {
  .add-bank-account-page { height: calc(100dvh - 56px); }
  .add-bank-account-shell { width: 100%; padding: 18px 14px 36px; }
  .add-bank-account-heading { align-items: flex-start; margin-bottom: 16px; }
  .heading-icon { flex-basis: 40px; width: 40px; height: 40px; }
  .add-bank-account-heading h2 { font-size: 20px; }
  .add-bank-account-heading p { font-size: 12px; }
  .add-bank-account-page ::v-deep .v-stepper__header { padding: 0 8px; }
  .add-bank-account-page ::v-deep .v-stepper__step { flex-basis: auto; padding: 16px 8px; }
  .add-bank-account-page ::v-deep .v-stepper__label { display: block; font-size: 11px; }
  .add-bank-account-page ::v-deep .v-stepper__content { padding: 18px 14px 24px; }
  .form-actions { flex-direction: column-reverse; }
  .add-bank-account-page ::v-deep .form-actions .v-btn,
  .add-bank-account-page ::v-deep .btn-account { width: 100% !important; }
  .add-bank-account-page ::v-deep .back-button {
    flex-basis: auto;
    margin-left: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
